export const AttributeTypeEnum = [
    { id: 'text', name: 'Text' },
    { id: 'textarea', name: 'Textarea' },
    { id: 'file', name: 'File' },
    { id: 'yes_no', name: 'Yes/No' },
    { id: 'select', name: 'Select' },
    { id: 'multiselect', name: 'Multiselect' },
    { id: 'checkbox', name: 'Checkbox' },
    { id: 'radio', name: 'Radio' },
    { id: 'datetime', name: 'Datetime' },
    { id: 'price', name: 'Price' },
    { id: 'number', name: 'Number' }
];

export const AttributeOptionTypeEnum = [
    'select',
    'multiselect',
    'checkbox',
    'radio',
];

export const AttributeMetaTypeEnum = {
    text: [
        {
            code: "required",
            name: "Required",
            type: "yes_no"
        },
        {
            code: "minLength",
            name: "Minimum Length",
            type: "number"
        },
        {
            code: "maxLength",
            name: "Maximum Length",
            type: "number"
        },
        {
            code: "pattern",
            name: "Pattern (Regex)",
            type: "text"
        }
    ],
    textarea: [
        {
            code: "required",
            name: "Required",
            type: "yes_no"
        },
        {
            code: "minLength",
            name: "Minimum Length",
            type: "number"
        },
        {
            code: "maxLength",
            name: "Maximum Length",
            type: "number"
        }
    ],
    file: [
        {
            code: "required",
            name: "Required",
            type: "yes_no"
        },
        {
            code: "allowedExtensions",
            name: "Allowed Extensions",
            type: "text"
        },
        {
            code: "maxSizeMB",
            name: "Maximum File Size (MB)",
            type: "number"
        }
    ],
    yes_no: [
        {
            code: "required",
            name: "Required",
            type: "yes_no"
        }
    ],
    select: [
        {
            code: "required",
            name: "Required",
            type: "yes_no"
        },
        {
            code: "allowedValues",
            name: "Allowed Values",
            type: "text"
        }
    ],
    multiselect: [
        {
            code: "required",
            name: "Required",
            type: "yes_no"
        },
        {
            code: "allowedValues",
            name: "Allowed Values",
            type: "text"
        },
        {
            code: "minItems",
            name: "Minimum Items",
            type: "number"
        },
        {
            code: "maxItems",
            name: "Maximum Items",
            type: "number"
        }
    ],
    checkbox: [
        {
            code: "required",
            name: "Required",
            type: "yes_no"
        }
    ],
    radio: [
        {
            code: "required",
            name: "Required",
            type: "yes_no"
        },
        {
            code: "allowedValues",
            name: "Allowed Values",
            type: "text"
        }
    ],
    datetime: [
        {
            code: "required",
            name: "Required",
            type: "yes_no"
        },
        {
            code: "format",
            name: "Format",
            type: "text"
        },
        {
            code: "min",
            name: "Minimum Date/Time",
            type: "datetime"
        },
        {
            code: "max",
            name: "Maximum Date/Time",
            type: "datetime"
        }
    ],
    price: [
        {
            code: "required",
            name: "Required",
            type: "yes_no"
        },
        {
            code: "min",
            name: "Minimum Price",
            type: "number"
        },
        {
            code: "max",
            name: "Maximum Price",
            type: "number"
        },
        {
            code: "precision",
            name: "Decimal Precision",
            type: "number"
        }
    ],
    number: [
        {
            code: "required",
            name: "Required",
            type: "yes_no"
        },
        {
            code: "min",
            name: "Minimum Value",
            type: "number"
        },
        {
            code: "max",
            name: "Maximum Value",
            type: "number"
        },
        {
            code: "precision",
            name: "Decimal Precision",
            type: "number"
        },
        {
            code: "unit",
            name: "Unit of Measure",
            type: "select",
            options: [
                { label: "Millimeter (mm)", value: "mm"}, 
                { label: "Centimeter (cm)", value: "cm"},
                { label: "Meter (m)", value: "m"},
                { label: "Kilometer (km) ", value: "km"},
                { label: "Milliliter (mL)", value: "mL"},
                { label: "Liter (L)", value: "L"},
                { label: "Miligram (mg)", value: "mg"},
                { label: "Gram (g)", value: "g"},
                { label: "Kilogram (kg)", value: "kg"},
                { label: "Tonne (t)", value: "t"}
            ]
        },
        {
            code: "unitCovert",
            name: "Unit to Convert",
            type: "select",
            options: [
                { label: "Millimeter (mm)", value: "mm"}, 
                { label: "Centimeter (cm)", value: "cm"},
                { label: "Meter (m)", value: "m"},
                { label: "Kilometer (km) ", value: "km"},
                { label: "Milliliter (mL)", value: "mL"},
                { label: "Liter (L)", value: "L"},
                { label: "Miligram (mg)", value: "mg"},
                { label: "Gram (g)", value: "g"},
                { label: "Kilogram (kg)", value: "kg"},
                { label: "Tonne (t)", value: "t"}
            ]
        }
    ]
};